export default `<!-- File typically in /sections/ directory-->
<!-- SparkLayer product matrix script-->
<spark-product-matrix parent-id="{{ product.id }}"></spark-product-matrix>
<!-- Hide any element by adding data-spark="b2c-only" to it, e.g. -->
<div data-spark="b2c-only">
    <!-- This would hide anything inside-->
</div>
`;
